import React, { createContext, useContext, useEffect, useState } from "react";
import { getMe } from "../api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out, object = logged in
  const [ready, setReady] = useState(false);

  const loadMe = async () => {
    const token = localStorage.getItem("mt5_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    try {
      const me = await getMe();
      setUser(me);
    } catch (_) {
      localStorage.removeItem("mt5_token");
      setUser(false);
    } finally {
      setReady(true);
    }
  };

  useEffect(() => {
    loadMe();
  }, []);

  const signIn = (token, u) => {
    localStorage.setItem("mt5_token", token);
    setUser(u);
  };

  const signOut = () => {
    localStorage.removeItem("mt5_token");
    setUser(false);
  };

  const refreshUser = loadMe;

  return (
    <AuthContext.Provider value={{ user, ready, signIn, signOut, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}
